import React from "react";

const DetailSkeleton = () => (
  <div className="animate-pulse">
    <div className="h-4 w-24 my-1 bg-gray-300 rounded-md"></div>
  </div>
);

export default DetailSkeleton;
